<a md-button [routerLink]="[this.invoiceID()]">
	<md-icon [icon]="icon()"></md-icon>
</a>
